module.exports = "/packs/006-c6593809982b88f107eefc6405b482f2.jpg";